import React, { Component } from "react";
import TranslationView from "../../../../../../components/translation/TranslationView";
import InfoDialogBaseView from "../../../../components/InfoDialogBase/InfoDialogBaseView";
import InfoDialogTextView from "../../../../components/InfoDialogBase/InfoDialogText/InfoDialogTextView";
import InfoDialogTitleView from "../../../../components/InfoDialogBase/InfoDialogTitle/InfoDialogTitleView";
import InfoDialogSubtitleView from "../../../../components/InfoDialogBase/InfoDialogSubtitle/InfoDialogSubtitleView";

export default class NoAvailabilityView extends Component {

    render() {
        return (
            <InfoDialogBaseView>
                <InfoDialogTitleView>
                    <TranslationView style={{ fontWeight: 300 }}>
                        confirmationSent
                    </TranslationView>
                </InfoDialogTitleView>

                <InfoDialogSubtitleView>
                    <TranslationView style={{ fontWeight: 500 }}>
                        maybeNextTime
                    </TranslationView>
                </InfoDialogSubtitleView>

                <InfoDialogTextView>
                    <TranslationView style={{ fontWeight: 300 }}>
                        thankYouAnswer
                    </TranslationView>
                </InfoDialogTextView>
            </InfoDialogBaseView>
        );
    }
}